import ApiResponse from "@/server/responses/ApiResponse";
import DuelResults from "@/server/structures/DuelResults";

export default class ApiResponse_GetDuelResults extends ApiResponse {

    get results() {
        return new DuelResults(this._rawResponse.data);
    }
}
